import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { extract } from '../../util/util';
import api from '../../services/api';
import './styles.css';
import notify from '../../services/notify';
import { clearParticipantAuth } from '../../util/authSession';
import { usePermissoes } from '../../context/PermissoesContext';
import { PERFIS_AEREO } from '../../util/malhaAereo';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const permissoes = usePermissoes();

  async function handleLogin(e) {
    e.preventDefault();
    if (loading) return;

    const usuario = (email || '').trim();
    const senhaDigitada = (senha || '').trim();

    if (!usuario) {
      notify.warning('Informe seu usuário.');
      return;
    }

    if (!senhaDigitada) {
      notify.warning('Informe sua senha.');
      return;
    }

    setLoading(true);

    try {
      const response = await api({
        method: 'post',
        action: '/login',
        data: { email: usuario, senha }
      });
      var dadosRecebidos = extract({
        jsonLaravel: response.data,
        chaves: []
      });


      // O cargo simulado do login anterior não passa para este.
      localStorage.removeItem('perfilReal');
      if (dadosRecebidos.cargo && dadosRecebidos.cargo.perfil) {
        localStorage.setItem('perfil', dadosRecebidos.cargo.perfil.codigo);
      } else {
        localStorage.removeItem('perfil');
      }

      localStorage.setItem('idUsuario', dadosRecebidos.id);
      localStorage.setItem('nomeUsuario', dadosRecebidos.nome);
      localStorage.setItem('token', dadosRecebidos.api_token);
      clearParticipantAuth();
      // As telas restritas do usuário que entrou: as do login anterior não passam para este.
      permissoes.limpar();
      await permissoes.recarregar();
      if (localStorage.getItem('perfil') === 'operadorrsvp') { //tela de operador
        history.push('/cadastroEventoParticipanteOperador');
      } else if (localStorage.getItem('perfil') === 'listarsvp') { //tela de lista digital
        history.push('/evento');
      } else if (localStorage.getItem('perfil') === 'suplier') {
        history.push('/evento');
      } else if (localStorage.getItem('perfil') === 'backofficeinterno') {
        history.push('/evento');
      } else if (PERFIS_AEREO.includes(localStorage.getItem('perfil'))) { //tela Aéreo, o painel do Aéreo
        history.push('/aereo');
      } else if (['briefing', 'cliente'].includes(localStorage.getItem('perfil'))) { //tela de briefing para clientes
        history.push('/briefingCliente');
      } else { //todos os outros usuarios normais
        history.push('/principal');
      }
    } catch (err) {
      notify.apiError(err, 'Falha no login, tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div id="auth" className="login-auth-shell">
      <div className="login-split-layout">
        <section
          className="login-hero-panel"
          aria-hidden="true"
          style={{ backgroundImage: 'url(/imagens/evento.png)' }}
        >
          <div className="login-hero-overlay" />
          <div className="login-hero-orb login-hero-orb--one" />
          <div className="login-hero-orb login-hero-orb--two" />
          <div className="login-hero-line login-hero-line--one" />
          <div className="login-hero-line login-hero-line--two" />
          <div className="login-hero-content">
            <p className="login-hero-kicker">Plataforma de Gerenciamento de Eventos</p>
            <h1 className="login-hero-title">Gestão de eventos da concepção à entrega.</h1>
            <div className="login-hero-tagline">
              <span>#A GENTE</span>
              <span>ENTREGA,</span>
              <span>E PONTO.</span>
            </div>
          </div>
        </section>

        <section className="login-form-panel">
          <div className="login-form-card">
            <div className="login-form-brand">
              <img alt="Access" src="/logo192.png" className="login-form-logo" />
              <p>Informe seu e-mail e senha para acessar o painel</p>
            </div>

            <form onSubmit={handleLogin} noValidate>
              <div className="form-group position-relative has-icon-left">
                <label htmlFor="nome">Usuário</label>
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    id="nome"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoComplete="username"
                    required
                  />
                  <div className="form-control-icon">
                    <FaEnvelope />
                  </div>
                </div>
              </div>

              <div className="form-group position-relative has-icon-left">
                <label htmlFor="senha">Senha</label>
                <div className="position-relative">
                  <input
                    type="password"
                    className="form-control"
                    id="senha"
                    value={senha}
                    onChange={e => setSenha(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <div className="form-control-icon">
                    <FaLock />
                  </div>
                </div>
              </div>

              <div className="login-form-links">
                <Link to="/recuperar-senha" className="login-link-reset">Recuperar senha</Link>
              </div>

              <button className={`btn btn-primary login-submit-btn ${loading ? 'is-loading' : ''}`} type="submit" disabled={loading}>
                {loading && <span className="auth-btn-spinner" aria-hidden="true" />}
                <span>{loading ? 'Entrando...' : 'Entrar'}</span>
              </button>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
}
